<template>
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g>
                    <g transform="translate(-8 -120) translate(0 53) translate(0 57) translate(8 10)">
                        <circle class="svg-circle" cx="6" cy="6" r="6"/>
                        <path fill-rule="nonzero" d="M6.432 7.471l.21-4.724H5.035l.221 4.724h1.176zm-.588 2.384c.462 0 .85-.389.85-.84 0-.462-.388-.85-.85-.85-.462 0-.84.388-.84.85 0 .451.378.84.84.84z"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
    name: 'import-error-icon'
}
</script>